@use '../styles/tokens' as *;

.page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: $blue-gray-9;
}

.fullPageLoading {
  position: relative;
  flex: 1;
}

.main {
  position: relative;
  max-width: $content-max;
  margin: 0 auto;
  padding: 30px 15px 60px;

  @include lg {
    padding: 30px 60px 80px;
  }
}

.grid {
  display: flex;
  flex-direction: column;

  @include lg {
    flex-direction: row;
    align-items: flex-start;
    gap: 32px;
  }
}

.left {
  display: contents;

  @include lg {
    display: block;
    flex: 1;
    min-width: 0;
  }

  > * {
    order: 2;
  }

  > *:first-child {
    order: 0;
  }
}

// ----- Checkout steps -----
.step {
  display: flex;
  flex-direction: column;
  padding: 40px 0;
  gap: 16px;
  border-bottom: 1px solid $blue-gray-7;

  @include lg {
    padding: 40px 0;
    &:first-child {
      padding-top: 0;
    }
  }
}
.stepTitle {
  @include text-heading-3;
  margin: 0;
  color: $black;
}
.stepTitleLocked {
  color: $base-6;
}

.overviewList {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

// ----- Product overview card -----
.poCard {
  display: flex;
  gap: 20px;
  align-items: flex-start;
  padding: 15px;
  background: $white;
  border-radius: $radius-card;
}
.poLogo {
  flex: none;
  width: 48px;
  height: 48px;
  border-radius: 6px;
}
.poBody {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;

  @include lg {
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
}
.poIntro {
  flex: 1;
  min-width: 0;
}
.poName {
  @include text-heading-4;
}
.poSub {
  @include text-11;
  color: $base-4;
}
.poControls {
  display: flex;
  align-items: flex-end;
  gap: 16px;
}
.poPrice {
  flex: none;
  min-width: 98px;
  margin-left: auto;
  text-align: right;
  align-self: flex-start;
}

// ----- Mail step -----
.mailInner {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
  max-width: 450px;
}
.field {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.fieldLabel {
  @include text-13;
  color: $base-4;
}
.fieldError {
  font-size: 11px;
  color: $brand;
}
.input {
  height: 46px;
  padding: 0 15px;
  border: 1px solid white;
  border-radius: 4px;
  background: $white;
  @include text-13;
  color: $black;
  outline: none;

  &:focus {
    border-color: $utility-blue;
  }

  &::placeholder {
    color: #ababab;
  }
}
.mailBtn {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 46px;
  padding: 0 40px;
  border: none;
  border-radius: 999px;
  background: $utility-blue;
  @include text-13;
  font-weight: 700;
  color: $white;
  &:disabled {
    background-color: $base-6;
    border-color: $base-6;
    cursor: auto;
  }
}

// ----- Collapsed Mail summary + edit -----
.stepHead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
}
.editBtn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border: 1px solid $blue-gray-7;
  border-radius: 8px;
  background: $white;
  @include text-13;
  color: $base-4;
}
.editIcon {
  width: 14px;
  height: 14px;
}
.mailSummary {
  display: flex;
  flex-direction: column;
}
.mailSummaryName {
  @include text-body-2;
  font-weight: 600;
  color: $black;
}
.mailSummaryEmail {
  @include text-13;
  color: $base-4;
}

// ----- Billing / Payment fields -----
.fieldsWrap {
  display: flex;
  flex-direction: column;
  gap: 40px;
  width: 100%;
  max-width: 450px;
  padding-bottom: 30px;
}
.group20 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}
.group10 {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
.optional {
  @include text-body-2;
  font-weight: 700;
  color: $black;
}
.row {
  display: flex;
  gap: 10px;
  width: 100%;
}
.grow {
  flex: 1 0 0;
  min-width: 0;
}
.wZip {
  width: 100px;
  flex: none;
}

.formField {
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;
}
.formLabel {
  @include text-13;
  color: $base-4;
}
.control {
  position: relative;
  width: 100%;
}
.controlBox {
  width: 100%;
  height: 46px;
  padding: 0 15px;
  border: 1px solid white;
  border-radius: 4px;
  background: $white;
  @include text-13;
  color: $black;
  text-align: left;
  outline: none;

  &:focus {
    border-color: $utility-blue;
  }

  &::placeholder {
    color: #ababab;
  }

  &.error {
    border: 1px solid $brand;
    &:focus {
      border-color: $brand;
    }
  }
}
.controlBoxIcon {
  padding-right: 44px;
}

.selectBox {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.selectChevron {
  flex: none;
  width: 18px;
  height: 18px;
  color: $base-4;
}
.nativeSelect {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.selectChevronOverlay {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

// ----- Legal fine print -----
.spacer {
  height: 50px;
}
.legal {
  @include text-10;
  color: $base-5;

  p {
    margin: 0 0 6px;
  }
  a {
    color: $utility-blue;
    text-decoration: none;
  }
}

// ----- Continue shopping -----
.continueRow {
  display: flex;
  margin-top: 80px;
}
.continueBtn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 0;
  border: none;
  background: none;
  @include text-13;
  font-weight: 700;
  color: $black;
  text-decoration: none;
}
.continueIcon {
  width: 18px;
  height: 18px;
}

// ----- Order summary sidebar -----
.summary {
  display: flex;
  flex-direction: column;
  gap: 20px;
  order: 1;
  margin: 10px 0;

  @include lg {
    width: 450px;
    flex-shrink: 0;
    margin: 0;
  }
}
.summaryBox {
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: $radius-box;

  @include lg {
    background: $white;
    padding: 30px;
    gap: 25px;
  }
}
.summaryTitle {
  @include text-body-2;
  font-weight: 600;
  color: #0090ff;
  display: none;

  @include lg {
    display: block;
  }
}

// ----- Always included card -----
.included {
  display: none;
  flex-direction: column;
  gap: 5px;
  padding: 15px;
  background: $blue-gray-8;
  border-radius: 8px;

  @include lg {
    display: flex;
  }
}
.includedTitle {
  @include text-body-2;
  font-weight: 600;
  color: $blue-gray-1;
}
.includedList {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

// ----- Trust box -----
.trustBox {
  padding: 32px;
  background: $white;
  border-radius: $radius-box;
  display: none;
  @include lg {
    display: block;
  }
}
.trustTitle {
  @include text-13;
  font-weight: 700;
  color: $blue-gray-2;
}
.trustRow {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-top: 5px;
}
.trustRating {
  flex: 1;
}
.trustReviews {
  margin-top: 8px;
  @include text-11;
  color: $blue-gray-4-5;
}
.medal {
  width: 62px;
  height: 70px;
  flex: none;
}
